import { HttpErrorResponse } from '@angular/common/http';

export function getServerError(responseError: HttpErrorResponse) {
  return (
    responseError?.error?.message ||
    responseError?.error ||
    responseError?.message
  );
}
